import React, { useRef, useState } from 'react'

import { Button, Flex } from '@chakra-ui/react'

import { allFileTypes } from '@/utils/constants'

const NonFormUpload = ({ uploadHandler, fileType = allFileTypes, title = 'Upload' }) => {
  const [file, setFile] = useState(null)
  const fileInput = useRef()
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0])
    }
  }

  return (
    <Flex gap={1} alignItems={'center'}>
      <Button colorScheme="green" onClick={() => uploadHandler(file)}>
        {title}
      </Button>
      <input type="file" accept={fileType} name="file" ref={fileInput} onChange={handleFileChange} />
    </Flex>
  )
}

export default NonFormUpload
